import { useState } from 'react'
import { LocationSectionHeader } from './LocationSectionHeader'
import { ItemRow } from './ItemRow'

type Props = {
  locationId:    string
  label:         string
  items:         any[]
  urgentCount:   number
  expiringCount: number
  onItemClick:   (item: any) => void
  onAdjustQty?:  (item: any) => void
  // Select mode plumbing
  selectMode?:           boolean
  selectedIds?:          Set<string>
  onToggleItem?:         (id: string) => void
  onSelectAllInSection?: (locationId: string) => void
}

export function LocationGroup({
  locationId, label, items, urgentCount, expiringCount, onItemClick, onAdjustQty,
  selectMode = false, selectedIds, onToggleItem, onSelectAllInSection,
}: Props) {
  const [isOpen, setIsOpen] = useState(() => urgentCount > 0 || expiringCount > 0)

  // Force-open the section while the user is in select mode so they can
  // actually see the rows they're picking. This avoids a confusing "Select
  // all" tap on a collapsed section that ticks invisible items.
  const open = selectMode || isOpen

  const allInSectionSelected =
    !!selectedIds &&
    items.length > 0 &&
    items.every(it => selectedIds.has(it.id))

  return (
    <div className="mb-1">
      <div className="border-b border-border-sand">
        <LocationSectionHeader
          label={label}
          itemCount={items.length}
          urgentCount={urgentCount}
          isOpen={open}
          onToggle={() => setIsOpen(o => !o)}
          selectMode={selectMode}
          allInSectionSelected={allInSectionSelected}
          onSelectAllInSection={onSelectAllInSection ? () => onSelectAllInSection(locationId) : undefined}
        />
      </div>
      {open && (
        <div className="overflow-hidden rounded-b-[14px] mb-3">
          {items.map(item => (
            <ItemRow
              key={item.id}
              item={item}
              onClick={() => onItemClick(item)}
              selectMode={selectMode}
              selected={selectedIds?.has(item.id) ?? false}
              onToggle={onToggleItem ? () => onToggleItem(item.id) : undefined}
              onAdjustQty={onAdjustQty}
            />
          ))}
        </div>
      )}
    </div>
  )
}
